import React, { useState, useContext } from "react";
import { Drawer, Select, notification, Icon, Input } from "antd";
import axios from "axios";
import { GlobalContext } from "../../../../app/providers/GlobalState";

import { noimage } from "../../../../assets";

const { Option } = Select;
const openNotificationWithIcon = (type, message, description) => {
    notification[type]({
        message: message,
        description: description
    });
};

function DrawerPesquisar({ onClose, participantes, visibleDrawerPesquisar, selecionarParticipante }) {
    const { Search } = Input;

    const globalContext = useContext(GlobalContext);
    const [loadingPesquisa, setLoadingPesquisa] = useState(false);
    const [visibleDrawerInscrever, setVisibleDrawerInscrever] = useState(false);
    const [pesquisaUtilizadores, setPesquisaUtilizadores] = useState("");
    const [inputPesquisarUtilizadores, setInputPesquisaUtilizadores] = useState([]);
    //const [participantes, setParticipantes] = useState([]);

    const pesquisarUtilizador = value => {
        if (value) {
            setLoadingPesquisa(true); // mostra o spinner enquanto carrega

            axios({
                method: "get",
                url: "/api/gerir-videoconferencia/pesquisar-participantes",
                params: {
                    pesquisa: value,
                    cursoid: localStorage.getItem("codigo_curso")
                }
            })
                .then(response => {
                    setInputPesquisaUtilizadores(response.data); // atualiza os dados
                    setLoadingPesquisa(false);
                })
                .catch(() => {});
        } else {
            setInputPesquisaUtilizadores([]); // limpa os resultados se campo for apagado
        }
    };

    const afterVisibleChange = aberto => {
        if (aberto) {
            setLoadingPesquisa(false);
            setVisibleDrawerInscrever(false);
            setPesquisaUtilizadores("");
            setInputPesquisaUtilizadores([]);
            //setParticipantes(participantes);
        }
    };

    return (
        <Drawer
            className="drawer-inscrever"
            //title="Pesquisar"
            width={720}
            onClose={onClose}
            visible={visibleDrawerPesquisar}
            style={{
                overflow: "auto",
                height: "calc(100% - 108px)",
                paddingBottom: "108px"
            }}
            maskClosable={false}
            afterVisibleChange={afterVisibleChange}
        >
            <div className="bloco-drawer-associar">
                <div className="pesquisar">
                    <Search
                        placeholder="Coloque o nome ou o código a pesquisar..."
                        onChange={e => setPesquisaUtilizadores(e.target.value)}
                        onSearch={pesquisarUtilizador}
                        style={{ width: 400 }}
                        allowClear={true}
                        value={pesquisaUtilizadores}
                    />
                </div>
                <div className="listagem" style={{ marginTop: 30 }}>
                    {loadingPesquisa ? (
                        <div className="loading-data">
                            <div className="loading" />
                        </div>
                    ) : (
                        <div className="lista-participantes">
                            {inputPesquisarUtilizadores.map((participante, index) => (
                                <div key={index} className="participante">
                                    <div className="info-participante">
                                        <div className="container-img">
                                            <img src={participante.foto ? participante.foto : noimage} />
                                        </div>
                                        <div className="info">
                                            <span className="nome">{participante.nome}</span>
                                            <p className="numero">{participante.numero}</p>
                                        </div>
                                    </div>
                                    <div className="opcoes">
                                        {participantes.find(x => x.id === participante.id) ? (
                                            <button className="botao-principal botao-adicionar-disable" disabled title="Adicionado">
                                                <Icon type="plus" />
                                            </button>
                                        ) : (
                                            <button
                                                className="botao-principal botao-adicionar"
                                                title="Adicionar"
                                                onClick={() => selecionarParticipante(participante)}
                                            >
                                                <Icon type="plus" />
                                            </button>
                                        )}
                                    </div>
                                </div>
                            ))}
                        </div>
                    )}
                </div>
            </div>
            <div className="ant-drawer-footer">
                <button className="botao-secundario" onClick={onClose} style={{ marginRight: 20, display: "inline-block" }}>
                    Voltar
                </button>
            </div>
        </Drawer>
    );
}

export default DrawerPesquisar;
